import phpClient from '../phpAPI_Config'
import { tsWhoAmI } from '../../../Typescript/API_Response'

async function sendPrintVessel(
  authState: tsWhoAmI,
  card_printer: string,
  sample_run_id: number,
) {
  return await phpClient(authState)
    .get<any>(
      `/json/stuart/printing/printVessel.php?DeviceID=${card_printer}&VesselID=V${sample_run_id}`,
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

const CodeSetService = {
  sendPrintVessel,
}

export default CodeSetService
